module.exports = __webpack_public_path__ + "img/cutting-edge-cn-2.039b669.jpg";